import React from 'react';
import styles from './Title.module.scss';
import clsx from 'clsx';

interface TitleProps {
  title: string;
  align?: TitleAlignType;
  icon?: boolean;
}

export type TitleAlignType = 'left';

const Title = ({title, align, icon}: TitleProps) => {
  return (
    <div className={clsx(styles.TitleWrapper, align === 'left' && styles.left)}>
      <h2 className={styles.MainTitle}>
        {title}
        {icon && <span className={styles.Icon} />}
      </h2>
    </div>
  );
};

export default Title;
